import { Link } from "react-router-dom";
import { ShoppingCart, Lock, Sparkles } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { formatARS, isNewProduct } from "@/lib/api";

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const { user } = useAuth();
  const low = product.stock > 0 && product.stock <= 5;
  const out = product.stock <= 0;
  const canSeePrice = !!user;
  const isNew = isNewProduct(product);

  return (
    <div className="card-product group fade-in" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="aspect-square bg-slate-50 p-6 flex items-center justify-center relative overflow-hidden">
        <div className="absolute top-3 left-3 flex flex-col items-start gap-1.5 z-10">
          {isNew && (
            <span className="inline-flex items-center gap-1 bg-green-600 text-white text-[10px] uppercase tracking-wider font-bold px-2 py-1 rounded-full shadow-sm" data-testid={`new-badge-${product.id}`}>
              <Sparkles className="w-3 h-3" /> Nuevo
            </span>
          )}
          {product.featured && (
            <span className="bg-red-500 text-white text-[10px] uppercase tracking-wider font-bold px-2 py-1 rounded-full">Destacado</span>
          )}
        </div>
        {low && !out && (
          <span className="absolute top-3 right-3 bg-amber-500 text-white text-[10px] uppercase tracking-wider font-bold px-2 py-1 rounded-full">Últimas unidades</span>
        )}
        {out && (
          <span className="absolute top-3 right-3 bg-slate-700 text-white text-[10px] uppercase tracking-wider font-bold px-2 py-1 rounded-full">Sin stock</span>
        )}
        <img
          src={product.image || "https://images.unsplash.com/photo-1556228578-8c89e6adf883?q=80&w=800"}
          alt={product.name}
          onError={(e) => { e.currentTarget.src = "https://images.unsplash.com/photo-1556228578-8c89e6adf883?q=80&w=800"; }}
          className="w-full h-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </Link>
      <div className="p-5 flex flex-col gap-2 flex-grow">
        <span className="text-xs font-semibold uppercase tracking-wider text-blue-600" data-testid={`product-category-${product.id}`}>{product.category}</span>
        <Link to={`/product/${product.id}`} className="font-heading font-semibold text-slate-900 hover:text-blue-700 line-clamp-2" data-testid={`product-name-${product.id}`}>
          {product.name}
        </Link>
        <div className="flex items-end justify-between mt-auto pt-2">
          {canSeePrice ? (
            <>
              <span className="text-xl font-bold text-slate-900" data-testid={`product-price-${product.id}`}>{formatARS(product.price)}</span>
              <button
                onClick={() => addItem(product, 1)}
                disabled={out}
                className="p-2.5 rounded-full bg-green-600 hover:bg-green-700 disabled:bg-slate-300 disabled:cursor-not-allowed text-white transition-colors"
                data-testid={`add-to-cart-${product.id}`}
                aria-label="Agregar al carrito"
              >
                <ShoppingCart className="w-4 h-4" />
              </button>
            </>
          ) : (
            <Link to="/login" className="w-full inline-flex items-center justify-center gap-2 bg-slate-100 hover:bg-blue-50 hover:text-blue-700 text-slate-700 rounded-full px-3 py-2 text-sm font-medium transition-colors" data-testid={`login-to-see-price-${product.id}`}>
              <Lock className="w-3.5 h-3.5" /> Iniciá sesión para ver precio
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
